module.exports = __webpack_public_path__ + "static/media/orange x20.1cfd200a.svg";